export function searchPermissions(controlador, accion, arregloDePermisos) {
  for (const permiso of arregloDePermisos) {
    if (permiso.idPermisoWebNavigation) {
      if (
        permiso.idPermisoWebNavigation.controlador === controlador &&
        permiso.idPermisoWebNavigation.accion === accion && permiso.idPermisoWebNavigation.estatus === true
      ) {
        return true;
      }
      if (permiso.idPermisoWebNavigation.inverseIdPermisoPadreNavigation) {
        for (const inverso of permiso.idPermisoWebNavigation
          .inverseIdPermisoPadreNavigation) {
          if (
            inverso.controlador === controlador &&
            inverso.accion === accion && inverso.estatus === true
          ) {
            return true;
          }

          if (inverso.inverseIdPermisoPadreNavigation) {
            for (const inversoHijo of inverso.inverseIdPermisoPadreNavigation) {
              if (
                inversoHijo.controlador === controlador &&
                inversoHijo.accion === accion && inversoHijo.estatus === true
              ) {
                return true;
              }
            }
          }
        }
      }
    }
  }
  return null;
}
